import { useContext, useState } from "react";
import { AuthContext } from "../../providers/auth-provider/AuthProvider";
import { VerifyOtp } from "./VerifyOtp";
import { EnterPhoneNumber } from "./EnterPhoneNumber";

export enum VerificationState {
  VERIFY_OTP = "VERIFY_OTP",
  RESEND_OTP = "RESEND_OTP",
  ENTER_PHONE_NUMBER = "ENTER_PHONE_NUMBER",
}

export enum GateAccessSecurityOptions {
  PLUS = 0,
  ENHANCED = 1,
  BASIC = 2,
}

export const GoatSecuritySmsVerificationWrapper = ({ children }: { children: React.ReactNode }) => {
  const { phoneNumber, bypassNumber } = useContext(AuthContext);

  if (
    _context.companySettings.gateAccessSecurityLevel ===
      GateAccessSecurityOptions.BASIC ||
    !!phoneNumber
  ) {
    return children;
  }

  if (
    bypassNumber &&
    _context.companySettings.gateAccessSecurityLevel ===
    GateAccessSecurityOptions.ENHANCED
  ) {
    console.log("allowUnauthenticated && bypassNumber");
    return children;
  }

  return (
    <SmsVerificationWrapper
      bypassText="Prefer to use a gate code? Click here"
      allowBypassOtp={
        _context.companySettings.gateAccessSecurityLevel ===
        GateAccessSecurityOptions.ENHANCED
      }
    >
      {children}
    </SmsVerificationWrapper>
  );
};

export const SmsVerificationWrapper = ({
  children,
  allowBypassOtp,
  bypassText,
}: {
  children: React.ReactNode;
  allowBypassOtp?: boolean;
  bypassText?: string;
}) => {
  const { phoneNumber } = useContext(AuthContext);

  const [phoneNumberState, setPhoneNumberState] = useState<null | string>(null);
  const [section, setSection] = useState(VerificationState.ENTER_PHONE_NUMBER);

  if (phoneNumber) {
    return children;
  }

  if (section === VerificationState.VERIFY_OTP) {
    return (
      <VerifyOtp
        allowUnauthenticated={allowBypassOtp}
        bypassText={bypassText}
        phoneNumberState={phoneNumberState}
        section={section}
        setSection={setSection}
      />
    );
  }

  if (
    section === VerificationState.ENTER_PHONE_NUMBER ||
    section === VerificationState.RESEND_OTP
  ) {
    return (
      <EnterPhoneNumber
        phoneNumberState={phoneNumberState}
        setPhoneNumberState={setPhoneNumberState}
        setSection={setSection}
        section={section}
      />
    );
  }
};
